import { expValNoExposure } from '@atlaskit/tmp-editor-statsig/expVal';

import { isStreamingUxExperienceM1EnabledNoExposure } from './streaming-ux-experience-m1-enabled';

/**
 * Whether the frontend (in-editor) Review moment auto-open is enabled.
 *
 * Requires the M1 master experiment and the `isFrontendReviewMomentEnabled` param
 * on `platform_editor_ai_new_aifc_editor_experience`. Read via the no-exposure
 * variant because canonical exposure is already logged by
 * `isNewAifcExperienceEnabled` on the same paths. Mirrors
 * `isDiffBasedSegmentingEnabled`.
 */
export function isFrontendReviewMomentEnabled(): boolean {
	return (
		expValNoExposure(
			'platform_editor_ai_new_aifc_editor_experience',
			'isFrontendReviewMomentEnabled',
			false,
		) && isStreamingUxExperienceM1EnabledNoExposure()
	);
}
